import { BaseLanguage } from "./baseLang.service";
import { SemanticErrorCause, SyntaxErrorCause } from "app/xlogo-parser";

export class SpanishService extends BaseLanguage {
  //#################################################################################
  //
  // This service holds hashmap containing all german strings used in our platform
  // When translating, please keep keys (first argument) same, while
  // adapting the values (seconds argument).
  //
  //#################################################################################

  constructor() {
    super();

    this.populateStaticStrings();
    this.defineGridTeachertoolStrings();
    this.defineGridExerciseStrings();
    this.defineLoginStrings();
    this.defineExamStrings();
    this.defineOnlineStorageStrings();
    this.defineQickStartStrings();
    this.defineRuntimeErrorStrings();
    this.defineSemanticErrorStrings();
    this.defineSyntaxErrorStrings();
    this.defineDebugWatchStrings();
    this.defineDebugControls();
    this.defineTooltips();
    this.defineProgressStrings();
    this.defineRobotStrings();
    this.defineUIstrings();
    this.defineMenuStrings();
    this.defineTaskStrings();
    this.defineAnimalNames();
  }

  // strings for animal names in header
  private defineAnimalNames(){
    this.define("green", "Violeta Verde");
    this.define("crystal", "Teresita Transparente");
    this.define("triangle", "Tomás Triángulo");
    this.define("lizard", "Leo Lagarto");
    this.define("dragon", "Daniel Dragón");
    this.define("bug", "Eddy Escarabajo");
    this.define("bee", "Ana Abeja");
    this.define("bumblebee", "Alba Abejorro");
    this.define("turtle", "Tony Tortuga");
    this.define("butterfly", "Maria Mariposa");
  }

  // strings for execises in stage 1
  private defineTaskStrings(){
    this.define("task.1", "Encuentra la fresa.");
    this.define("task.2", "Encuentra la fresa.");
    this.define("task.3", "Encuentra la fresa.");
    this.define("task.4", "Encuentra la fresa.");
    this.define("task.5", "Encuentra la fresa.");
    this.define("task.6", "Encuentra la fresa.");
    this.define("task.7", "Encuentra la fresa.");
    this.define("task.8", "Encuentra la fresa.");
    this.define("task.9a", "Encuentra la fresa.");
    this.define("task.9b", "Encuentra el limon.");
    this.define("task.10a", "Encuentra la fresa sólo con dos comandos.");
    this.define("task.10b", "Encuentra la fresa sin ir hacia atrás.");
    this.define("task.11", "Encuentra la fresa solo con los tres comandos: adelante, adelante y a la derecha.");
    this.define("task.12a","Encuentra la fresa y empieza con ir adelante.");
    this.define("task.12b","Encuentra la fresa y empieza con girar a la izquierda.");
    this.define("task.13", "Encuentra la fresa.");
    this.define("task.14", "Encuentra la fresa.");
    this.define("task.15", "Encuentra la fresa.");
    this.define("task.16", "Encuentra la fresa.");
    this.define("task.17a", "Encuentra la fresa y empieza con 'adelante, adelante, a la derecha'.");
    this.define("task.17b", "Encuentra la fresa y empieza con 'adelante, adelante, a la izquierda'.");
    this.define("task.18a", "Encuentra dos caminos diferentes hacia la fresa.");
    this.define("task.18b", "Encuentra la fresa y gira sólo exactamente una vez.");
    this.define("task.19", "Encuentra la fresa.");
    this.define("task.20", "Encuentra el círculo rojo.");
    this.define("task.21", "Encuentra el círculo azul.");
    this.define("task.22", "Encuentra el círculo verde, sin que pases sobre el rojo.");
    this.define("task.23", "Encuentra el círculo naranja, sin que pases sobre el violeta.");
    this.define("task.24", "Encuentra primero el círculo naranja, después el negro y al último el círculo verde.");
    this.define("task.25", "En que casilla esta la tortuga después del siguiente programa: 'izquierda atrás atrás derecha adelante'.");
    this.define("task.26", "Encuentra el cuadrado rojo.");
    this.define("task.27", "Junta todas las figuras azules.");
    this.define("task.28", "Junta todas las figuras verdes sin que pases sobre una cruz.");
    this.define("task.29", "Junta las 8 fresas.");
    this.define("task.30", "¿Cuántas fresas encuentra la tortuga con el siguiente programa: 'adelante izquierda adelante'.");
    this.define("task.31", "Junta exactamente 4 fresas");
    this.define("task.32a", "Junta exactamente 5 fresas");
    this.define("task.32b", "Junta exactamente 6 fresas");
    this.define("task.33", "Junta exactamente 9 fresas");
    this.define("task.34", "Junta exactamente 9 fresas");
    this.define("task.35", "¿Qué nombre de chica se esconde aquí?");
    this.define("task.36", "¿Qué nombre de chico se esconde aquí?"); 
    this.define("task.37", "¿Qué ropa se esconde aquí?"); 
    this.define("task.38", "¿Qué fecha se esconde aquí?"); 
    this.define("task.39a", "Busca el nombre 'PETRA'.");
    this.define("task.39b", "Busca el nombre 'ULA'.");
    this.define("task.40", "");
    this.define("task.41", "");
    this.define("task.42", "");
    this.define("task.43", "");
    this.define("task.44", "");
    this.define("task.45", "");
    this.define("task.46", "");
    this.define("task.47", "");
    this.define("task.48", "");
    this.define("task.49", "");
    this.define("task.50", "");
    this.define("task.51", "");
    this.define("task.52", "");
    this.define("task.53", "");
    this.define("task.54", "");
    this.define("task.55", "");
    this.define("task.56", "");
    this.define("task.57", "");
    this.define("task.58", "");
    this.define("task.59", "");
    this.define("task.60", "");
    this.define("task.61", "");
    this.define("task.62", "");
    this.define("task.63", "");
    this.define("task.64", "");
    this.define("task.65", "");
    this.define("task.66", "");
    this.define("task.67", "");
    this.define("task.68", "");
    this.define("task.69", "");
    this.define("task.70", "");
    this.define("task.71", "");
    this.define("task.72", "");
    this.define("task.73", "");
    this.define("task.74", "");
    this.define("task.75", "");
    this.define("task.76", "");
    this.define("task.77", "");
    this.define("task.78", "");
    this.define("task.79", "");
    this.define("task.80", "");
    this.define("task.81", "");
    this.define("task.82", "");
    this.define("task.83", "");
    this.define("task.84", "");
    this.define("task.85", "");
    this.define("task.86", "");
    this.define("task.87", "");
    this.define("task.88", "");
  }

  // strings used in menu
  private defineMenuStrings(){
    this.define("menu", "Menu");
    this.define("saveFile", "Guardar archivo");
    this.define("loadFile", "Cargar archivo");
    this.define("saveCanvas", "Guardar lienzo");
    this.define("fullscreen", "Pantalla completa");
    this.define("newfeatures", "¿Qué hay de nuevo?");
    this.define("Cheatsheet", "Guía");
    this.define("background", "Imágenes de fondo");
    this.define("save-as-png", "Guardar como png");
    this.define("save-as-svg", "Guardar como svg");
    this.define("Robot", "Robots");
  }

  // user interface strings: history, header, input and general UI
  private defineUIstrings(){
    this.define("enterCommand", "Itroduce los comandos aqui");
    this.define("cancel", "cancelar");
  }

  // Robots interaction strings for BlueBot and Root
  private defineRobotStrings(){
    this.define("WhichRobotUsed", "¿Que robot utilizas?");
    this.define("disconnectBlueBot","BlueBot ya esta conectado. ¿Quiere desconectar?");
    this.define("RobotConnected","Root ya esta conectado. ¿Quiere desconectar?");
    this.define("ConnectionNotPossible", "No se puede conectar");
    this.define("ConnectionError","La computadora/El navegador no soporta dispositivos Bluetooth Low Energy. " +
        "Actualiza el controlador de Bluetooth o intenta conectar con otro aparato o navedagor.");
    this.define("RobotDisconnect", "Si, desconectar");
  }

  //Progress strings shown in header while execution
  private defineProgressStrings(){
    this.define("executingVisitor", "Ejecutando comandos...");
    this.define("init", "Inicializando...");
  }

  // Strings related to tooltips in header
  private defineTooltips(){
    this.define("tooltipButtonStop", "Parar ejecución");
    this.define("tooltipButtonDebug", "Ejecutar tu programa paso a paso");
    this.define("tooltipButtonForward","Retroceder al paso anterior");
    this.define("tooltipButtonBackward", "Ejecutar el siguiente paso");
    this.define("tooltipButtonSpeed", "Ajustar velocidad");
    this.define("tooltipButtonLanguage", "Cambiar de idioma");
    this.define("tooltipButtonTurtle", "Cambiar de tortuga");
  }

  // Strings related to debug controls in header
  private defineDebugControls(){
    this.define("buttonDebugToggle", "Paso a paso");
    this.define("buttonForward", "Adelantar");
    this.define("buttonBackward", "Retroceder");
  }

  // Strings related to ebug watch
  private defineDebugWatchStrings(){
    this.define("watchPenDown", "Lápiz bajado:");
    this.define("watchErasing", "Borrando:");
    this.define("watchVisible", "Visible:");
    this.define("watchColor", "Color del lápiz:");
    this.define("watchWidth", "Ancho del lápiz");
    this.define("watchDirection", "Orientación:");
  }

  // Strings related to syntactic errors
  private defineSyntaxErrorStrings(){
    this.define(SyntaxErrorCause[SyntaxErrorCause.EXTRANEOUS_INPUT], "Carácter superfluo {extraneousToken}.");
    this.define(SyntaxErrorCause[SyntaxErrorCause.MISMATCHED_INPUT],"Carácter inválido {mismatchedToken}. ");
    this.define(SyntaxErrorCause[SyntaxErrorCause.MISSING_INPUT], "Falta un carácter {missingToken} antes de {missingPosition}");
    this.define(SyntaxErrorCause[SyntaxErrorCause.NO_VIABLE_ALT], "Code inválido en position {no_viable_alt_position}");
    this.define(SyntaxErrorCause[SyntaxErrorCause.UNKNOWN], "Error desconocido: {msg}");
    this.define(SyntaxErrorCause[SyntaxErrorCause.FAILED_PREDICATE], "{msg}"); //this one should not be used. It indicates an unexpected error on our side
  }

  // Strings related to semantic errors
  private defineSemanticErrorStrings(){
    this.define(SemanticErrorCause[SemanticErrorCause.DOUBLE_DECLARATION_PROGRAM_NAME], "Este nombre de programa ya lo has utilizado");
    this.define(SemanticErrorCause[SemanticErrorCause.DOUBLE_DECLARATION_PROGRAM_PARAMETER],"Este nombre de parámetro ya lo has utilizado: {parameter}");
    this.define(SemanticErrorCause[SemanticErrorCause.INVALID_PROGRAM_NAME],"Este nombre de programa no esta permitido");
    this.define(SemanticErrorCause[SemanticErrorCause.NOT_ENOUGH_ARGUMENTS],"Faltan parámetros para '{program}'. Estan esperados {number_of_arguments} parámetros.");
    this.define(SemanticErrorCause[SemanticErrorCause.TOO_MANY_ARGUMENTS],"Demasiado parámetros para '{program}'. Estan esperados {number_of_arguments} parámetros.");
    this.define(SemanticErrorCause[SemanticErrorCause.NO_SUCH_PROGRAM],"El programa '{program}' no existe o contiene errores");
    this.define(SemanticErrorCause[SemanticErrorCause.NO_SUCH_VARIABLE],"La variable o el parámetro '{variable}' no ha sido definido.");
  }

  // Strings related to runtime errors
  private defineRuntimeErrorStrings(){
    this.define("runtime_error_generic","{msg}");
    this.define("runtime_error_unknown_program","El programa '{program}' no existe o contiene errores");
    this.define("runtime_error_unknown_function","La function {function_name} no existe. Esto es un Bug. Favor de avisarnos.");
    this.define("runtime_error_unknown_builtin","El comando '{command}' no existe. Esto es un Bug. Favor de avisarnos.");
    this.define("runtime_error_unknown_operator","El operador '{operator}' no existe. Esto es un Bug. Favor de avisarnos.");
    this.define("runtime_error_generic_invalid_argument","Parameter invalido para '{program}': {argument}");
    this.define("runtime_error_division_by_zero","No se puede dividir por 0.");
    this.define("runtime_error_generic_not_in_range","El parametro de {program} debe ser {lower_bound} y {upper_bound}");
    this.define("runtime_error_invalid_argument_tan","El parametro para tan no debe tener la forma de (0.5 + k) * PI");
    this.define("runtime_error_mod_by_zero","No es posible de calcular mod n 0");
    this.define("runtime_error_invalid_argument_colornumber","Ese número de color no existe: {color_number}");
    this.define("runtime_error_invalid_argument_colorname","Ese nombre de color no existe: {color_name}");
    this.define("runtime_error_invalid_argument_rgb", "El valor de un color tiene que ser un número: {color}");
    this.define("runtime_error_rgb_out_of_range","Color invalido: {color}");
    this.define("runtime_error_sqrt_negative_number","La raiz de números negativos no se puede calcular.");
    this.define("runtime_error_log10_negative_number", "El logaritmo de números negativos no se puede calcular.");
    this.define("runtime_error_setpw_negative_number","No hay lápiz con gruesa negativa.");
    this.define("runtime_error_wait_negative_number","No es posible de esperar una duración negativa.");
    this.define("runtime_error_circle_negative_number","No es posible de dibujar un circulo con radio negativo.");
  }

  // Strings related to quickstarter
  private defineQickStartStrings(){
    this.define("tutorialtype", "Seleccione un tutorial.");
    this.define("doyouneedhelp", "Necesitas ayuda?");
    this.define("firststeps", "Primeros pasos");
    this.define("definenewcommands", "Nombrar nuevos comandos");
    this.define("debugger", "Modo paso-a-paso");
    this.define("intro1","Bienvenido a XLogoOnline. En este tutorial vas a aprender a programar diseños en color.");
    this.define("intro2", "¡Mira, la tortuga pinta und mandala! El dibujo es el resultado de un programa.");
    this.define("intro3", "Un programa consiste de comandos. FD y BK son comandos. Esos dos comandos se usan para dibujar linias. RT y LT son comandos para girar la tortuga a la derecha y a la izquierda.");
    this.define("intro4", "¡Ensaya tu! Haga clic en el campo y confirme con ENTER");
    this.define("intro5", "La tortuga ejecuta cada comando. El resultado lo puedes ver en la pantalla.");
    this.define("intro6", "Borra el dibujo con el comando CS.");
    this.define("intro7","CS borra todas las líneas y devuelve la tortuga al centro.");
    this.define("intro8", "Un programa puede consistir de varios comandos. Trata de descubrir lo que vamos a dibujar.");
    this.define("intro9", "Todos los programas que hamos ejecutados estan notados uno detras del otro.");
    this.define("intro10", "Con la FLECHA HACIA ARRIBA " + String.fromCharCode(8679) + " y HACIA ABAJO " + String.fromCharCode(8681) + " se pueden reutilisar programas sin deber de insertar las otra vez.");
    this.define("intro11", "Que pasa si hacemos un error?");
    this.define("intro12","Este programa contiene errores. Ves el error? Mira ver como la tortuga reacciona a programas con errores.");
    this.define("intro13", "La tortuga no comprendio las instrucciones. En vez del dibujo vemos información sobre el error y la causa del error (en color anaranjado).");
    this.define("intro14", "¡Vamos, empezamos a programar!");
    this.define("editor1","En este tutorial te vamos a mostrar como nombrar y utilizar tus propios comandos.");
    this.define("editor2","Este programa parece muy complicado. Puedes adivinar qué es lo que hace?");
    this.define("editor3","¿Impresionante, no? Un porgrama tan complicado, solo para dibujar cuatro cuadrados.");
    this.define("editor4","Y si tratamos de hacerlo mas sencillo..");
    this.define("editor5","Dasafortunadamente eso no funciona. La tortuga no conoce el comando CUADRADO. Pero nosotros podemos definir y nombrar nuestros propios comandos.");
    this.define("editor6","Nuestros comandos propios los definimos aqui. Este campo se llama editor.");
    this.define("editor7","'TO' CUADRADO 'END' definede und nuevo comando con el nombre CUADRADO." );
    this.define("editor8","Puedes definir varios comandos en la misma ventana.");
    this.define("editor9","¡Ay no! ¿Ves la cruz roja en la línea 5?  La cruz indica que tu programa tiene un error en esta línea. ¡El comando CUADRADO ha sido definido mas que una vez! (Consejo: Al final de este tutorial puedes pasar con el mouse sobre la cruz y recibir mas información sobre el error.)");
    this.define("editor10", "Las instrucciones para dibujar un CUADRADO las escribimos entre las dos líneas con TO y END. Usa los comandos que ya conoces.");
    this.define("editor11","¿Qué pasa si usamos nuestro nuevo comando CUADRADO? ¡Ensaya tu!");
    this.define("editor12","¡Dibujamos un cuadrado con solo un comando! ¡Que bien! Y ahora también podemos dibujar dibujos mas complicados con pocos comandos.");
    this.define("editor13","¡Felicitaciones! Has definido tu primer propio comando (en el editor) y lo has usado con suceso.");
  }

  // Strings related to storage functionality
  private defineOnlineStorageStrings(){
    this.define("loginButton", "Login");
    this.define("logoutButton", "Logout");
    this.define("registerButton", "Soy nuevo aqui...");
    this.define("loginTitle", "Login");
    this.define("username", "Nombre de usuario");
    this.define("password", "Contraseña (opcional)");
    this.define("successfulLoginTitle", "Ingreso exitoso");
    this.define("successfulLoginText", "Estas iniciado como ");
    this.define("failLoginTitlen", "Intento de login fallido");
    this.define("tryAgain", "¡Ensaya otra vez!");
    this.define("registerTitle", "Registrarse");
    this.define("repeatPassword", "Repitir contraseña");
    this.define("passwordMisatchTitle", "Error");
    this.define("passwordMisatchText","Las dos contraseñas no son idénticas. Ensayar otra vez?");
    this.define("successfulRegistrationTitle", "La registración fue un suceso");
    this.define("successfulRegistrationText","¡Felicitaciones! La registración fue un suceso y estas iniciado como ");
    this.define("serversuccess", "Suceso");
    this.define("unknownuser", "Nombre de usuario desconocido");
    this.define("wrongpassword", "Contraseña incorrecta");
    this.define("usernamealreadytaken","Nombre de usuario ya existe.");
    this.define("Ihaveread", "He leído y comprendido la");                              //diese Zeilen  werden kombiniert dargestellt
    this.define("datenschutz", "política de privacidad y protección de datos");                     //diese Zeilen  werden kombiniert dargestellt
    this.define("aswellas", "y los");                                     //diese Zeilen  werden kombiniert dargestellt
    this.define("terms", "términos y condiciones de utilización");                           //diese Zeilen  werden kombiniert dargestellt
    this.define("readandaccepted", "y los acepto");  //diese Zeilen  werden kombiniert dargestellt
    this.define("toomuchtext", "El tamaño del archivo es demasiado grande");
    this.define("toomuchtexthint","Consejo: Cada tarea se puede guardar en un archivo separado.");
    this.define("documentexists", "Ese archivo ya existe");
    this.define("overwrite", "¿Desea sobrescribirlo?");
    this.define("writtensuccessfully", "Archivo guardado con suceso");
    this.define("doYouWantToLogOut", "¿Quieres cerrar la sesión?");
    this.define("didYouSaveYourPrograms","¿Has guardado todos tus programas?");
    this.define("announceTitle", "Búsquar tarea");
  }

  // Strings related to Exam mode
  private defineExamStrings(){
    this.define("handInTask", "Entregar tarea");
    this.define("choseAnOption", "Selecciona una opción");
    this.define("startExamMode", "Tareas de concurso");
    this.define("waitingForExamToStart", "Listo. Vamos a empezar pronto.");
    this.define("examFinished","El concurso ha terminado.");
    this.define("checkingForExam", "Cargar tareas...");
    this.define("cancelExamModeButton", "Cancelar");
    this.define("enterExamModeButton", "Cargar tareas...");
    this.define("infoRecognition", "Introducir código de acceso.");
    this.define("notauthorizedTitle", "Por favor haga el login");
    this.define("notauthorizedText","Para participar en el concurso tienes que hacer el login");
  }

  // Strings related to login
  private defineLoginStrings() {
    this.define("notingtosave", "No hay nada a guardar. \n El editor esta vacío...");
    this.define("howtosave", "¿Como quieres guardar tus programas?");
    this.define("save", "Guardar");
    this.define("locally", "Local");
    this.define("online", "Online");
    this.define("load", "Cargar programa");
    this.define("noconnection", "Error de conexión");
    this.define("filename", "Nombre de mi archivo:");
    this.define("login", "Login: ");
    this.define("chapterx", "Capítulo X Tarea Y");
    this.define("loadprogram", "Cargar progama:");
    this.define("chooseprogram", "Selcciona un programa");
    this.define("youcanloadandstore", "Guardar/cargar archivos online " + "\u2192" + " en el menú");
    this.define("logoutsuccess", "Logout fue un suceso");
  }

  // Strings related to Larissa's Grid Service (Exercise Mode for Version 1)
  private defineGridExerciseStrings(){
    this.define("exercise", "Tarea ");
    this.define("chapter", "Capítulo ");
    this.define("solveExercise", "Resolver un problema");
    this.define("createExercise", "Inventar una tarea");
    this.define("upload-exercise", "Búsqueda de tareas");
    this.define("choose-exercise", "Elija una tarea");
    this.define("next", "más");
    this.define("prev", "volver");
    this.define("eatenObjects", "Objetos recogidos:");
    this.define("runIntoWall", "¡Te has estrellado contra un muro!");
    this.define("leaveGrid", "¡Se ha escapado del campo!");
    this.define("forbiddenField", "¡Has entrado en un campo prohibido!");
    this.define("congratulations", "¡Felicidades!");
    this.define("exSolved", "Has resuelto la tarea");    
    this.define("or", "O");
  }

  // Strings related to Larissa's Grid Setrvice (Exercise creation/Teachertool)
  private defineGridTeachertoolStrings(){
    this.define("chooseDragAndDropElements","Los elementos pueden ser arrastrados a los campos.");
    this.define("enterTaskName", "Definición de la tarea");
    this.define("createYourGrid", "Crea tu propia tarea...");
    this.define("turtles", "Tortuga");    
    this.define("lettersAndNumbers", "Letras y números");
    this.define("colors", "Colores");
    this.define("shapes", "Formas");
    this.define("fruits", "Frutas");
    this.define("houses", "Casas");
    this.define("walls", "Paredes");
    this.define("buttonDrawExercise", "Resolver");
    this.define("buttonUploadServer", "Compartir en línea");
    this.define("buttonLocalDownload", "Descargue");
    this.define("buttonClear", "Nuevo");
    this.define("noTurtle", "¡Tu tarea debe incluir una tortuga!");
    this.define("key", "Código de acceso");
    this.define("doesNotExist", "no existe");
  }

  // These strings are static and DO NOT need to be TRANSLATED! :-)
  populateStaticStrings() {
    this.define("XLogoOnline", "XLogoOnline");
  }
}



// WEBPACK FOOTER //
// ./src/app/languages/spanish.service.ts